import strings from './getRollupText.locstring.json';
import type InboxViewType from 'owa-service/lib/contract/InboxViewType';
import { getStore } from '../store/store';
import loc, { format } from 'owa-localize';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Get rollup text for current folder
 */
export default function getRollupText(viewType: InboxViewType, mailboxInfo: MailboxInfo): string {
    const unseenCount = getStore(mailboxInfo).unseenCountToDisplay;

    switch (viewType) {
        case 1:
            return format(loc(strings.focusedRollupText), unseenCount);
        case 2:
            return format(loc(strings.otherRollupText), unseenCount);
    }

    return '';
}
